import React, {useEffect} from 'react';
import './App.css';
import {fetchTVGuide} from "./utilities/dataSources";
import {SatelliteLogo} from "./components/SatelliteLogo";
import "react-datepicker/dist/react-datepicker.css";
import {ChannelsView} from "./components/ChannelsView";
import {ProgrammesView} from "./components/ProgrammesView";

function Loading() {
    const array = ['/happy_tvs_3.jpg', '/happy_tvs_2.jpg', '/happy_tvs_1.jpg', '/happy_tvs_4.jpg', '/happy_tvs_5.jpg','/happy_tvs_6.jpg'];
    const randomItem = array[Math.floor(Math.random() * array.length)];
    return (<div className="image-container">
        <img src={randomItem} alt="Loading"/>
        <div className="loading-caption">
            Loading your TV guide<span className="loading-dots"/>
        </div>
    </div>)
}

export type StartEndTime = {
    startTime: string;
    endTime: string;
}

export type ShowTime = {
    dateYYYMMDD?:string;
    date: string;
    startTime: string;
    endTime: string;
    channelNumber: string;
    channelName: string;
    uniqueEventId: string;
};

function Menu({tvGuide, country}: { tvGuide: any, country: 'south-africa' | 'nigeria' }) {
    const [selectedView, setSelectedView] = React.useState<string>('channels');
    const [focusSearchTrigger, setFocusSearchTrigger] = React.useState(0);

    const handleSwitchToProgrammes = () => {
        setSelectedView('programmes');
        setFocusSearchTrigger(prev => prev + 1);
    };

    return (
        <div className="App">
            <header className="App-header">
                <SatelliteLogo size={56}/>
                <h1 className="brand-title">Premium DStv Guide</h1>
                <p className="brand-sub">{country === 'south-africa' ? 'South Africa' : 'Nigeria'}</p>
                <div className="header-row">
                    <div className="tabs">
                        <div className={`tab ${selectedView === 'channels' ? 'selectedView' : ''}`}
                             onClick={_ => setSelectedView('channels')}>
                            Channels
                        </div>
                        <div className={`tab ${selectedView !== 'channels' ? 'selectedView' : ''}`}
                             onClick={_ => setSelectedView('programmes')}>
                            Programmes
                        </div>
                    </div>
                    <a href={'/game-studio/' + country} className="games-link" title="Game Studio">
                        🎮 <span>Games</span>
                    </a>
                    <a href={'/media/' + country} className="games-link media-link" title="Media">
                        🗞️ <span>Media</span>
                    </a>
                </div>
            </header>
            <main className="content">
                {selectedView === 'channels' ?
                    <ChannelsView tvGuide={tvGuide} country={country} onSwitchToProgrammes={handleSwitchToProgrammes}/> :
                    <ProgrammesView tvGuide={tvGuide} country={country} focusSearchTrigger={focusSearchTrigger}/>}
            </main>

            <footer className="app-footer">
                <a href={'/game-studio/' + country}>Game Studio (Beta)</a> · <a href={'/media/' + country}>Media</a>
            </footer>
        </div>
    );
}

function TvGuide({country}: { country: 'south-africa' | 'nigeria' }) {
    const [loading, setLoading] = React.useState<boolean>(true);
    const [tvGuide, setTVGuide] = React.useState<any>(null);
    useEffect(() => {
        if (loading) {
            Promise.all([fetchTVGuide(country), new Promise<boolean>((resolve, _) => {
                setTimeout(() => {
                    resolve(true);
                }, 5000);
            })]).then(responses => {
                setTVGuide(responses[0].data);
            }).finally(() => {
                setLoading(false);
            })
        }
    }, []);

    return loading ? <Loading/> : <Menu tvGuide={tvGuide} country={country}/>;
}

export default TvGuide;
